import Cookies from 'js-cookie';
import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetStitchFixClientQuery } from './getStitchFixClient';
import mockedResponse from './useStitchFixClient.mockedResponse';

const useStitchFixClientQuery = () => {
  const {
    data: clientData,
    loading: clientLoading,
    error: clientError,
  } = useGetStitchFixClientQuery({
    variables: {
      // Required to use prod data in development since the visitor uuid cookie can't be sent cross site.
      visitorId:
        /* @ts-ignore Property 'gon' does not exist on type 'Window & typeof globalThis'. */
        window.gon.env === 'development' ? Cookies.get('visitor_uuid') : null,
    },
    onCompleted: () => {
      recordMark('use_stitch_fix_client_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('use_stitch_fix_client_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(`useGetStitchFixClientQuery error for : ${clientError}`, {
        error_message: clientError,
      });
    },
  });

  // @ts-ignore Property 'gon' does not exist on type 'Window & typeof globalThis'.
  if (window.gon.use_mock_client_data) {
    return {
      clientData: mockedResponse.data,
      clientLoading,
      clientError,
    };
  }

  return {
    clientData,
    clientLoading,
    clientError,
  };
};

export default useStitchFixClientQuery;
